import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { usePriceLive } from '@ui/hooks/price/usePriceLive';
import { Nullable } from '@ui/types/utility';
import BigNumber from 'bignumber.js';
import { isNil } from 'lodash-es';
import { SystemStyleObject } from 'styled-system/types';

import { EditTpSlType, GenericTradeParams } from '../types';

type SizeUsdProps = {
  css: SystemStyleObject;
  type?: EditTpSlType;
  marketPrice?: Nullable<BigNumber>;
} & GenericTradeParams;

export const SizeUsd = (props: SizeUsdProps) => {
  const {
    genericTradeParams,
    css,
    type = EditTpSlType.POSITION,
    marketPrice,
  } = props;

  if (Object.prototype.hasOwnProperty.call(props, 'marketPrice')) {
    return (
      <SizeUsdValue
        genericTradeParams={genericTradeParams}
        css={css}
        type={type}
        marketPrice={marketPrice}
      />
    );
  }

  return (
    <SizeUsdWithHooks
      genericTradeParams={genericTradeParams}
      css={css}
      type={type}
    />
  );
};

const SizeUsdWithHooks = ({
  genericTradeParams,
  css,
  type = EditTpSlType.POSITION,
}: {
  css: SystemStyleObject;
  type?: EditTpSlType;
} & GenericTradeParams) => {
  const marketPrice = usePriceLive(genericTradeParams.pair.baseSymbol);

  return (
    <SizeUsdValue
      genericTradeParams={genericTradeParams}
      css={css}
      type={type}
      marketPrice={marketPrice}
    />
  );
};

const SizeUsdValue = ({
  genericTradeParams,
  css,
  type = EditTpSlType.POSITION,
  marketPrice,
}: {
  css: SystemStyleObject;
  type?: EditTpSlType;
  marketPrice?: Nullable<BigNumber>;
} & GenericTradeParams) => {
  const isPosition = type === EditTpSlType.POSITION;

  const size = isNil(marketPrice)
    ? undefined
    : isPosition
    ? genericTradeParams.getSizeUsd(marketPrice)
    : genericTradeParams.getSizeUsd(genericTradeParams.entryPrice);

  return (
    <AmountUsd css={css} value={size} data-cy="SizeUsd" data-cy-value={size} />
  );
};
